<!--
 * @Author: cp
 * @Date: 2019-08-22 17:17:11
 * @Description: 拣货
 -->
<template>
  <div v-loading="loading" class="list" element-loading-text="加载中">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <el-button type="primary" @click="printPicking">打印</el-button>
      <el-table ref="table1" class="fa_table" border :height="heightStyleObj" :data="pageListData"
        style="width:100%;margin-top: 10px" @selection-change="handleSelectionChange">
        <el-table-column type="expand" width="50px">
          <template slot-scope="props">
            <el-table :show-header="false" class="son_table" :data="props.row.goodsVoList" row-key="id"
              default-expand-all>
              <el-table-column class-name="cell1" width="50px">
              </el-table-column>
              <el-table-column class-name="cell2" width="55px">
              </el-table-column>
              <el-table-column width="80px"> </el-table-column>
              <el-table-column width="160px"> </el-table-column>
              <!-- 日期 -->
              <el-table-column width="200px"> </el-table-column>
              <!-- 单据编号 -->
              <el-table-column width="220px"> </el-table-column>
              <!-- 商品名称 -->
              <el-table-column show-overflow-tooltip prop="goodsName" width="220px" />
              <!--规格  -->
              <el-table-column show-overflow-tooltip prop="specification" width="100px" />
              <el-table-column show-overflow-tooltip prop="goodsCode" width="160px" />
              <!-- 批号 -->
              <el-table-column prop="batchNumber" show-overflow-tooltip />

              <!-- 数量 -->
              <el-table-column show-overflow-tooltip width="100px" prop="packageNumber" />
            </el-table>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="pickingStatus" label="打印状态" width="80px">
          <template slot-scope="scope">
            <dict-tag :options="dictObj.wms_print_status" :value="scope.row.pickingStatus" />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="pickingDate" label="打印日期" width="160px">
          <template slot-scope="scope">
            {{ scope.row.pickingDate ? parseTime(scope.row.pickingDate, '{y}-{m}-{d}') : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="specifyDeliveryDate" label="发货日期" width="200px">
          <template slot-scope="scope">
            {{ scope.row.specifyDeliveryDate ? parseTime(scope.row.specifyDeliveryDate, '{y}-{m}-{d}') : '' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="bizId" label="单据编号" width="140px" />
        <el-table-column show-overflow-tooltip prop="goodsName" label="物料名称" width="220px" />
        <el-table-column show-overflow-tooltip prop="specification" label="物料规格型号" width="100px" />
        <el-table-column show-overflow-tooltip prop="goodsCode" label="物料编码" width="160px" />
        <el-table-column show-overflow-tooltip prop="batchNumber" label="批号" />
        <el-table-column show-overflow-tooltip prop="actualTotal" label="数量" width="100px" />
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>
    <printPicking v-if="printPickingShow" :order-ids="multipleSelection" :visible="printPickingShow"
      @close="()=>{printPickingShow = false;getPageListData()}"></printPicking>
  </div>
</template>

<script>
import { getPickingList } from '@/api/orderManage'
import { getDict } from '@/api/common'
import printPicking from './components/PrintPicking'

export default {
  components: { printPicking },
  data() {
    return {
      dictObj: {
        wms_print_status: []
      },
      printPickingShow: false,
      queryItems: [
        {
          label: '关键字搜索',
          field: 'searchValue',
          type: 'input',
          placeholder: '单据编号/物料编码/批号/物料规格型号',
          width: '300px'
        },
        {
          label: '发货日期',
          field: 'specifyDeliveryDate',
          type: 'date'
        },
        {
          label: '打印状态',
          field: 'pickingStatus',
          type: 'select',
          options: [],
          dictType: 'wms_print_status'
        },

      ],
      // 拣货列表数据
      pageListData: [],
      loading: false,
      searchParam: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      multipleSelection: [],
      dialogTableVisible: false,
      heightStyleObj: ''
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 425 + 'px'
    this.getDicts(['wms_print_status'])
    this.getPageListData()
  },
  methods: {
    // 重置
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
          const findIndex = this.queryItems.findIndex(item => item.dictType === dictType)
          if (findIndex !== -1) {
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
        })
      })
    },

    getPageListData() {
      // 获取拣货列表数据
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.searchParam))
      if (params.specifyDeliveryDate) {
        const [startDate, endDate] = params.specifyDeliveryDate
        params.startDate = startDate
        params.endDate = endDate
        delete params.specifyDeliveryDate
      }
      getPickingList(params)
        .then(res => {
          this.pageListData = res.rows
          this.searchParam.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    printPicking() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: 'error',
          message: '请先选择拣货数据，再打印'
        })
        return
      }
      this.printPickingShow = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(item => item.orderId)
    },
    /**
     * 用于搜索框写入数据后重置数据
     */
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },

  }
}
</script>
